import SortableManager from '@wielink-application/shared/js/base/menu/SortableManager';
export default SortableManager;
